import { faPalette, faPlusCircle, faTableColumns } from "@fortawesome/pro-regular-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import type { TEmailBuilderActivePanel } from "redux/reducers/emailBuilder/emailBuilder";

export interface IEmailBuilderToolbarNavItem {
  id: Exclude<TEmailBuilderActivePanel, "none">;
  label: string;
  icon: IconDefinition;
}

export function emailBuilderToolbarNavItems(
  t: (key: string) => string,
): IEmailBuilderToolbarNavItem[] {
  return [
    {
      id: "add-elements",
      label: t("Add elements"),
      icon: faPlusCircle,
    },
    {
      id: "colors",
      label: t("Customize"),
      icon: faPalette,
    },
    {
      id: "templates",
      label: t("Templates"),
      icon: faTableColumns,
    },
  ];
}
